webpackJsonp([5],{

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(191);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("5229d685", content, true);

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, ".column-1[data-v-73560fb4],.column-2[data-v-73560fb4]{width:50%}", "", {"version":3,"sources":["/opt/build/repo/src/views/Discover.vue"],"names":[],"mappings":"AACA,sDAEE,SAAW,CACZ","file":"Discover.vue","sourcesContent":["\n.column-1[data-v-73560fb4],\n.column-2[data-v-73560fb4] {\n  width: 50%;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 192:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GoodItem__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GoodItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GoodItem__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      column1: [],
      column2: [],
      column1Height: 0,
      column2Height: 0,
      items: [{
        src: 'http://lorempixel.com/320/200/food/',
        imgWidth: 320,
        imgHeight: 200,
        title: '千年人参',
        desc: '千年的人参，送老人最合适了',
        price: 9999
      }, {
        src: 'http://lorempixel.com/320/240/business/',
        imgWidth: 320,
        imgHeight: 240,
        title: '进口化妆品',
        desc: '妮维雅进口化妆品，适合送女生',
        price: 1888
      }, {
        src: 'http://lorempixel.com/320/180/food/',
        imgWidth: 320,
        imgHeight: 180,
        title: '蟠桃',
        desc: '延年益寿，大补！',
        price: 888
      }, {
        src: 'http://lorempixel.com/320/140/food/',
        imgWidth: 320,
        imgHeight: 140,
        title: '新鲜水果',
        desc: '刚采摘的，串门啥的都可以',
        price: 100
      }, {
        src: 'http://lorempixel.com/320/220/business/',
        imgWidth: 320,
        imgHeight: 220,
        title: '请帖',
        desc: '各种请帖，支持定制！',
        price: 200
      }, {
        src: 'http://lorempixel.com/320/182/food/',
        imgWidth: 320,
        imgHeight: 182,
        title: '零食特卖',
        desc: '儿时的零食，送亲朋好友最合适不过了',
        price: 199
      }, {
        src: 'http://lorempixel.com/320/210/technics/',
        imgWidth: 320,
        imgHeight: 210,
        title: '电子鞭炮',
        desc: '不能放炮？那就放电子鞭炮！',
        price: 222
      }, {
        src: 'http://lorempixel.com/320/120/business/',
        imgWidth: 320,
        imgHeight: 120,
        title: '红包',
        desc: '塞点钱，给别人发红包吧！',
        price: 66
      }]
    };
  },

  components: {
    GoodItem: __WEBPACK_IMPORTED_MODULE_1__components_GoodItem___default.a
  },
  methods: {
    distribute: function distribute(items) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var goods = _step.value;

          if (this.column1Height > this.column2Height) {
            this.column2.push(goods);
            this.column2Height += goods.imgHeight;
          } else {
            this.column1.push(goods);
            this.column1Height += goods.imgHeight;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  },
  created: function created() {
    this.distribute(this.items);
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(194), __esModule: true };

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52);
__webpack_require__(51);
module.exports = __webpack_require__(195);


/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(4);
var get = __webpack_require__(53);
module.exports = __webpack_require__(3).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(199),
  /* template */
  __webpack_require__(200),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ef59ba2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(198);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(167)("aa4e8a70", content, true);

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(166)(true);
// imports


// module
exports.push([module.i, ".goods[data-v-3ef59ba2]{width:96%;margin:2%;border-radius:2px;border:1px solid rgba(0,0,0,.1)}.img[data-v-3ef59ba2]{width:100%}.footer[data-v-3ef59ba2]{padding:0 .32rem .10667rem}.title[data-v-3ef59ba2]{margin:.10667rem 0;color:#233040}.desc[data-v-3ef59ba2]{margin:.10667rem 0;color:#667180}.last[data-v-3ef59ba2]{padding:.10667rem 0}.price[data-v-3ef59ba2]{color:#e78081}.link[data-v-3ef59ba2]{padding:.10667rem .21333rem;color:#8081e7;background-color:#d9d9f8;border:1px solid #8081e7;border-radius:12px;font-size:12px;line-height:.32rem}", "", {"version":3,"sources":["/opt/build/repo/src/components/GoodItem.vue"],"names":[],"mappings":"AACA,wBACE,UAAW,AACX,UAAW,AAEX,kBAAmB,AACnB,+BAAkC,CACnC,AACD,sBACE,UAAY,CACb,AACD,yBACE,0BAA8B,CAC/B,AACD,wBACE,mBAAqB,AACrB,aAAe,CAChB,AACD,uBACE,mBAAqB,AACrB,aAAe,CAChB,AACD,uBACE,mBAAsB,CACvB,AACD,wBACE,aAAe,CAChB,AACD,uBACE,4BAA+B,AAC/B,cAAe,AACf,yBAA0B,AAC1B,yBAA0B,AAC1B,mBAAoB,AACpB,eAAgB,AAChB,kBAAqB,CACtB","file":"GoodItem.vue","sourcesContent":["\n.goods[data-v-3ef59ba2] {\n  width: 96%;\n  margin: 2%;\n/*box-shadow 1px 1px 5px 1px rgba(0, 0, 0, 0.15)*/\n  border-radius: 2px;\n  border: 1px solid rgba(0,0,0,0.1);\n}\n.img[data-v-3ef59ba2] {\n  width: 100%;\n}\n.footer[data-v-3ef59ba2] {\n  padding: 0 0.32rem 0.10667rem;\n}\n.title[data-v-3ef59ba2] {\n  margin: 0.10667rem 0;\n  color: #233040;\n}\n.desc[data-v-3ef59ba2] {\n  margin: 0.10667rem 0;\n  color: #667180;\n}\n.last[data-v-3ef59ba2] {\n  padding: 0.10667rem 0;\n}\n.price[data-v-3ef59ba2] {\n  color: #e78081;\n}\n.link[data-v-3ef59ba2] {\n  padding: 0.10667rem 0.21333rem;\n  color: #8081e7;\n  background-color: #d9d9f8;\n  border: 1px solid #8081e7;\n  border-radius: 12px;\n  font-size: 12px;\n  line-height: 0.32rem;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuex__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    goods: Object
  },
  data: function data() {
    return {
      height: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])(['viewport'])),
  methods: {
    calcHeight: function calcHeight() {
      if (this.$refs.goods) {
        this.height = lib.flexible.px2rem(this.$refs.goods.clientWidth / this.goods.imgWidth * this.goods.imgHeight + 'px');
      }
    }
  },
  watch: {
    'viewport.width': {
      immediate: true,
      handler: function handler() {
        this.calcHeight();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.calcHeight();
    });
  }
});

/***/ }),

/***/ 200:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "goods",
    staticClass: "goods"
  }, [_c('img', {
    staticClass: "img",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "src": _vm.goods.src,
      "alt": _vm.goods.src
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('p', {
    staticClass: "title t-ellipsis"
  }, [_vm._v(_vm._s(_vm.goods.title))]), _vm._v(" "), _c('p', {
    staticClass: "desc t-ellipsis"
  }, [_vm._v(_vm._s(_vm.goods.desc))]), _vm._v(" "), _c('div', {
    staticClass: "last flex flex-between flex-cross-center"
  }, [_c('span', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.goods.price))]), _vm._v(" "), _c('span', {
    staticClass: "link"
  }, [_vm._v("立即购买")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover flex flex-column flex-1"
  }, [_c('u-header', [_vm._v("发现美好事物")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scrollable container flex-1 flex flex-row"
  }, [_c('p', [_vm._v("开发中")])])
}]}

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(201),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73560fb4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/5.a58ed24a3c1215c0158e.js